module.exports = __webpack_public_path__ + "img/labmem_text_btntest_tc.d5840d0d.png";